<!-- begin #footer -->

<div id="footer" class="footer">
  &copy; {{ currentYear | date : "yyyy" }} ICP |
  <a href="https://www.icp.es/politica-de-privacidad-de-datos/" target="_blank">
    Uso de condiciones y Política de Privacidad de Datos
  </a>
  |
  <a href="https://www.icp.es/politica-de-cookies/" target="_blank">
    Política de cookies
  </a>
</div>

<!-- end #footer -->
